import {makeStyles} from "@material-ui/core/styles";
import {theme} from "../../../../../../../../../../shared/theme";

export default makeStyles({
    content: {
        maxHeight: "8em"
    },
    list: {
        overflowY: "auto",
        height: "100%",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.primary.dark
        }
    }
})

